import Styles from './spinner.module.css';
import SpinnerLight from './assets/spinner-light.svg';
import { TEST_ID } from './spinner.constants';

export function Spinner() {
  return (
    <div data-testid={TEST_ID.container} className={Styles.posCenter}>
      <img src={SpinnerLight} className={Styles.loader} alt="Loading" />
    </div>
  );
}
